<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ao0WVT/tc-custom/9781771643832.jpg?1737056306105" alt="This image is the cover for the book Sound"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sound
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A moving and fascinating book about sound and what it means to be human” from the Somerset Maugham Award–winning author of <i>The Lighthouse Stevensons</i> (<i>Financial Times</i>).</b><br/><br/> In this surprising and moving book, award-winning writer Bella Bathurst shares the extraordinary true story of how she lost her hearing and eventually regained it and what she learned from her twelve years of deafness. Diving into a wide-ranging exploration of silence and noise, she interviews psychologists, ear surgeons, and professors to uncover fascinating insights about the science of sound. But she also speaks with ordinary people who are deaf or have lost their hearing, including musicians, war veterans, and factory workers, to offer a perceptive, thought-provoking look at what sound means to us.<br/><br/> If sight gives us the world, then hearing—or our ability to listen—gives us our connections with other people. But, as this smart, funny, and profoundly honest examination reveals, our relationship with sound is both more personal and far more complex than we might expect.<br/><br/> “Bathurst is a restless, curious writer . . . After reading this book, I found myself listening in a richer and more interested way.” —<i>The Guardian</i><br/><br/> “A hymn to the faculty of hearing by someone who had it, lost it and then found it again, written with passion and intelligence . . . terrifying, absorbing and ultimately uplifting.” —<i>Literary Review</i><br/><br/> “Bathurst’s affecting memoir will enlighten and educate.” —<i>Publishers Weekly</i><br/><br/> “A memoir of hearing loss and what the author learned . . . through her unexpected recovery from it. A good writer knows material when it presents itself, and Bathurst is a very good writer.” —<i>Kirkus Reviews</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bella Bathurst
      </h2>
      
      <p class="authorDescription body article"><P><B>Bella Bathurst</B> is a writer, photojournalist, and furniture maker. She has written four nonfiction books, including <I>The Lighthouse Stevensons</I>, which won the 1999 Somerset Maugham Award, and a novel, <I>Special</I>, which was shortlisted for the Orange Prize for Fiction. Her writing has appeared in the <I>Guardian</I>, the <I>Observer</I>, and many other outlets.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      eBound
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08aa254c